
<style>
  body{background-color: black;}
  .container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  @media (min-width: 768px) {
    .container {
      width: 750px;
    }
  }
  @media (min-width: 992px) {
    .container {
      width: 970px;
    }
  }
  @media (min-width: 1200px) {
    .container {
      width: 1170px;
    }
  }

  .row  {
    margin-right: -15px;
    margin-left: -15px;

  }
  .col-md-12 {
    padding-left: 0px;
    padding-right: 0px;

   }

  .clock-center {
    margin: auto;
    position: absolute;
  top: 0;left: 0;bottom: 0;right: 0;
  }

  /*.container-fluid {*/
  /*  padding-right: 0;*/
  /*  padding-left: 0;*/
  /*  position: absolute;*/
  /*  padding-top: 0px;*/
  /*  height: 100%;*/
  /*}*/


</style>

<template >



  <div class="container-fluid min-height-100" ref="bgMusic" id="bgMusic" >
      <div class="col-md-12 vh-100">
        <div class="row vh-100">
          <div class="col-md-6 vh-100" :style="{ backgroundColor: bgColor,cursor: lpCursor }" ref="lp" id="lp"  >
            <Clock0  :style="{transform:'translate('+x+'px,'+y+'px)'}"   ></Clock0>

            <div id="PlayPre"  v-on:click="MusicPlay(0)" style="cursor: pointer;position: relative;right: 0px;margin-right: 0px;width: 200px;height: 200px;top: 0px;margin-left: auto;left: auto;"></div>
          </div>
          <div class="col-md-6 vh-100" :style="{ cursor: gardenCursor }"  ref="garden" id="garden"  >
            <div id="PlayNext"  v-on:click="MusicPlay(1)" style="cursor: pointer;position: relative;left: 0px;margin-left: 0px;width: 200px;height: 200px;top: 0px;"></div>


            <audio id="MusicPlayer" height="200" width="200"  preload="auto" controls  hidden="true"  autostart="true" autoplay="true"  loop="true" volume="0" :src="MusicUrl" >
              <source  :src="MusicUrl"  type="audio/mp3" />
              <embed height="50" width="100" src="" />
            </audio>


          </div>
        </div>

    </div>




</div>


</template>


<script>


  import Clock0 from '@/components/Clock0'
  import musicIndex from '../assets/musicindex'

  export default {
      name: "Index",
      data () {

        return {
          backgroundColor: "#000000", // 初始化背景颜色为红色
          bgColor: "#000000",
          lpCursor:'auto',
          gardenCursor:'auto',
          timer:'',
          ColorNum:0,
          x:0,
          y:0,
          screenWidth: 0,
          screenHeight: 0,
          ClockShow:false,
          MusicUrl:"https://cdn.1htr.cn/media/audio/birds.mp3",
          MusicPos:0,
          MusicClickType:0,
          MusicFlag:0

        }
      },
      components: {Clock0, musicIndex},

      beforeDestroy() {
        clearTimeout(this.timer);
      },
      mounted(){

        this.delayedTask(1);
        this.getScreenSize();
        this.MusicPlayCurrent();
        document.addEventListener('click',this.MusicPlayCurrent)
      },

      methods:{

        MusicPlayCurrent(){
          let date=new Date();
          let hours=date.getHours()
          let mins=date.getMinutes()
          this.MusicPos = Math.ceil(hours *4 + mins/15)
          this.MusicSelect(date)
          document.removeEventListener('click',this.MusicPlayCurrent)

        },
        isMobile() {   //判断是否为移动端
          const userAgent = navigator.userAgent || navigator.vendor || window.opera;
          return /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile/.test(userAgent);
        },
        getScreenSize() {
          this.screenWidth = window .innerWidth;//document.documentElement.clientWidth;//window.innerWidth;
          this.screenHeight = window.innerHeight;//document.documentElement.clientHeight;//window.innerHeight;
        },
        onMouseDown(e){
          alert(0);
          const startX=e.clientX;
          const startY=e.clientY;

          const onMouseMove=(e)=>{
            this.x+=e.clientX-startX;
            this.y+=e.clientY-startY;
            let startX=e.clientX;
            let startY=e.clientY
          }

          const onMouseUp=(e)=>{
            document.removeEventListener('mousemove',onMouseMove);
            document.removeEventListener('mouseup',onMouseUp);
          }

          document.addEventListener('mousemove',onMouseMove);
          document.addEventListener('mouseup',onMouseUp);
        },
        setBgColor(){

          setTimeout(() => {
            // 这里写需要延迟执行的逻辑代码
            this.bgColor="#ffffff";
            this.lpCursor="grab";
            this.gardenCursor="grabbing";


            $("#lp").on("click",(e)=>{
              if(e.target.id!="PlayPre" && window==window.top)
                    this.clickHref('/link.html',0);
            });

            $("#garden").on("click",(e)=>{
              if(e.target.id!="PlayNext")

                this.clickHref('/garden.html',1);

            });

          }, 100); // 延迟 5 秒执行
       },
        isInIframe() {
          return window.frames.length != parent.frames.length;
          //return window.frames.length > 0;
        },
        setBackgroundColor(step) {
          // console.log(step);
          this.ColorNum=this.ColorNum+step;

          let tmpColor=this.dec2hex(this.ColorNum);
          this.backgroundColor="#"+tmpColor+tmpColor+tmpColor;

          this.bgColor=this.backgroundColor;
          document.body.style.backgroundColor = this.backgroundColor;

          if (this.ColorNum>=255){
            clearTimeout(this.timer);
            this.delayedTask(-1);
          }
          if (this.ColorNum<=0){
            clearTimeout(this.timer);
            // this.delayedTask(1);
            this.setBgColor();
          }

        },
        delayedTask(step) {
          setTimeout(() => {
            // 这里写需要延迟执行的逻辑代码
            this.startTimer(step)
          }, 500); // 延迟 5 秒执行
        },
        startTimer(step) {
          let tmpStep=step;
          this.timer=setInterval(() => {

            this.setBackgroundColor(tmpStep)
            // 这里写需要定期执行的逻辑代码
          }, 5); // 每隔 1 秒执行一次
        },
        dec2hex(num){
          //定义用于映射的十六进制字符
          let hexChars ="0123456789ABCDEF";

          //定义结果和原始数字的变量
          let result ="";
          //将十进制数转换为十六进制字符串
          while(num> 0){
            let remainder = num %16;
            result = hexChars [remainder] + result;
            num = Math.floor(num / 16);
          }
          if (result.length==1)
            result="0"+result;

          return result;
        },
        clickHref(url='/lp',audioType=0){
          //location.href 获取和修改浏览器的请求地址
          //window.open(url);
          window.location=url;


        },
        MusicPlay(audioType){

          this.MusicClickType=audioType;
          if (this.MusicClickType==0){
             if (this.MusicPos==0)
               this.MusicPos=Math.ceil(Math.random()*100+1)

            this.MusicPos=this.MusicPos-1
          }
          else
            this.MusicPos=this.MusicPos+1

          let date=new Date();
          this.MusicSelect(date)

        },
        RandomMy(arr){

          let newArr = [];//创建一个新数组

          let num=Math.ceil(this.MusicPos % arr.length);

          newArr.push(arr[num]);
          if (num+1==arr.length)
            newArr.push(arr[0]);
          else
            newArr.push(arr[num+1]);


          // for (let i = 0; i < 2; i++) {
          //   let temp = Math.floor(Math.random()*arr.length);//取随机下标
          //   newArr.push(arr[temp]);//添加到新数组
          //   arr.splice(temp,1)//删除当前的数组元素,避免重复
          // }
          //随机抽取不重复的数组元素 很不错，不用删除，只是移动
          // var arr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
          // var result = [ ];
          // var ranNum = 5;
          // for (var i = 0; i < ranNum; i++) {
          //   var ran = Math.floor(Math.random() * (arr.length - i));
          //   result.push(arr[ran]);
          //   arr[ran] = arr[arr.length - i - 1];
          // };
          //mongodb+srv://knowfoot:<password>@cluster0.ysl90gf.mongodb.net/?retryWrites=true&w=majority
          return newArr;
        },
        MusicSelect(date){
          let hours=date.getHours();
          let arr=[];
          let MusicPlayer = document.getElementById("MusicPlayer");

          try{
              MusicPlayer.pause();

            } catch (e) {

            }


          if (hours>=8 && hours<18){
            arr=this.RandomMy(musicIndex.Day)

            this.MusicUrl= arr[this.MusicClickType].split(",")[2];


          }else if(hours>=18 && hours<=23){
            arr=this.RandomMy(musicIndex.Night)
            this.MusicUrl= arr[this.MusicClickType].split(",")[2];


          }else{
            arr=this.RandomMy(musicIndex.Sleep)
            this.MusicUrl= arr[this.MusicClickType].split(",")[2];

          }
          try{
             MusicPlayer.play();
          }catch (e) {
            // console.log(e);
          }


        },
        fatherMethod(date) {

          let percentPos=0;
          let hours=date.getHours()
          let mins=date.getMinutes()
          let secs=date.getSeconds()

          this.MusicFlag=this.MusicFlag<=0?0: this.MusicFlag-1;

          if (mins % 15==0 && this.MusicFlag<=0){
            this.MusicFlag=65;
            this.MusicPos = Math.ceil(hours *4 + mins/15)
            this.MusicSelect(date)
          }


            if(this.isMobile()){
              //手机 y不变，变x
              this.x=this.screenWidth/2-220;
              let YHalf=this.screenHeight/2-180;
              if (hours>=8 && hours<18){
                 percentPos=(((hours-8)*3600)+mins*60+  secs )/36000;
                this.y= percentPos*YHalf-40

              }else if(hours>=18 && hours<=23){
                 percentPos=(((hours-18)*3600)+mins*60+  secs)/21600;
                this.y= YHalf+percentPos*YHalf-40
              }else{
                this.y=-440
              }

            }
            else
            {
              //pc y不变，变x
              this.y=this.screenHeight/2-220;
              let XHalf=this.screenWidth/2-160;

              if (hours>=8 && hours<18){
                   percentPos=(((hours-8)*3600)+mins*60+  secs )/36000;
                  this.x= percentPos*XHalf-60

              }else if(hours>=18 && hours<=23){
                 percentPos=(((hours-18)*3600)+mins*60+  secs )/21600;
                 percentPos=(((hours-18)*3600)+mins*60+ secs)/21600;
                this.x= XHalf+percentPos*XHalf-60
              }else{
                this.x=-440
              }

            }

        }



      }
    }


</script>




// WEBPACK FOOTER //
// src/components/Index.vue